var exports = {
  "u": "x804f0401--cf710e--stars",
};

module.exports = exports;
